import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { useIntersectionTracking } from '../../shared/use-intersection-tracking';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import styles from './CancelAnytimeBlock.css';

function CancelAnytimeBlock({ title = 'Cancel anytime', subtitle = 'Cancel in 2 taps from your profile' }) {
    const trackingKey = useId();

    useIntersectionTracking(`[data-tracking-key="${trackingKey}"]`);

    return (
        <div
            className={styles.root}
            id={EVENT_TYPES.CANCEL_ANYTIME_BLOCK_VIEWED}
            data-tracking-key={trackingKey}
        >

            <div className={styles.header}>
                <div className={styles.iconWrapper}>
                    <Icon name='checked-2' className={styles.checkIcon} />
                </div>
                <div>
                    <p className={styles.title}>{title}</p>
                    <p className={styles.subtitle}>
                        {subtitle}
                    </p>
                </div>
            </div>
        </div>
    );
}

CancelAnytimeBlock.propTypes = {
    title: PropTypes.node,
    subtitle: PropTypes.node
};

export {
    CancelAnytimeBlock
};
